<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { durationName } from './format';
  const minutes = (s: number) => (s % 60 === 0 ? $_('report.focus.minutes', { values: { n: s / 60 } }) : s < 60 ? $_('report.focus.seconds', { values: { n: Math.round(s) } }) : $_('report.focus.min_sec', { values: { time: `${Math.floor(s / 60)}:${String(Math.round(s % 60)).padStart(2, '0')}` } }));

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // settings of a report: what the plan was set up with.
  export let settings: any;
  export let hero: any = null;

  $: rows = [
    settings?.focus ? [$_('report.focus.focus'), settings.focus] : null,
    settings?.target_duration_seconds ? [$_('report.focus.target_duration'), minutes(settings.target_duration_seconds)] : null,
    hero && hero.target && hero.start !== null && hero.target > hero.start && hero.unit === 'W' ? [$_('report.focus.goal_above'), `${Math.round(hero.target - hero.start)} W`] : null,
    settings?.specificity ? [$_('report.focus.specificity'), settings.specificity] : null,
    settings?.max_weekly_hours ? [$_('report.focus.max_hours'), $_('report.focus.hours', { values: { n: settings.max_weekly_hours } })] : null,
  ].filter(Boolean) as [string, string][];
</script>

{#if rows.length}
  <dl class="grid grid-cols-2 gap-x-3 gap-y-2 text-sm">
    {#each rows as [k, v]}<dt class="text-zinc-500">{k}</dt><dd class="text-right font-medium">{v}</dd>{/each}
  </dl>
{:else}
  <p class="text-sm text-zinc-500">{$_('report.focus.not_recorded')}</p>
{/if}
